import { IDayRepetition } from './iday-repetition';

export class DayRepetition implements IDayRepetition {
	public readonly type: string;
}
